import moda from "./data_moda";
import productosycomida from "./data_productosycomida";
import retratos from "./data_retratos";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    moda: [...moda],
    productosycomida: [...productosycomida],
    retratos: [...retratos]
}